/* global Razorpay */
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/store';
import CryptoJS from 'crypto-js';
import clock from '../../assets/clock.svg';
import Modal from './Modals/Modal';
import paymentFailed from '../../assets/paymentFail.gif';
import paymentStatus from '../../assets/paymentStatus.gif';
import paymentSuccess from '../../assets/paymentSuccess.gif';
import paymentPendingGif from '../../assets/paymentPending.gif';
const IndiaPayment = () => {
  const { paymentData, setPaymentData } = useStore();
  const [paymentPending, setPaymentPending] = useState(true);
  const [paymentID, setPaymentID] = useState(null); //pay_R4jBOFuGba928M
  const [appointmentID, setAppointmentID] = useState(null);
  const [startTimer, setStartTimer] = useState(false);
  const [minutes, setMinutes] = useState(9);
  const [seconds, setSeconds] = useState(0);
  const countDownRef = useRef(null);
  const pollingRef = useRef(null);
  const [contactSupport, setContactSupport] = useState(false);
  const [razorpayFail, setRazorpayFail] = useState(false);
  const [appointmentFailedMsg, setAppointmentFailedMsg] = useState(false);
  const [retryPayment, setRetryPayment] = useState(false);
  const [razorpayPending, setRazorpayPending] = useState(false);
  const openOnceRef = useRef(false);
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = ''; // required for Chrome
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);

  useEffect(() => {
    const loadScript = async () => {
      if (
        !paymentData.db_ptr ||
        !paymentData.authToken ||
        !paymentData.order_id
      )
        return;
      if (openOnceRef.current) return;
      try {
        await loadRazorpayScript();
        openOnceRef.current = true;
        openRazorpay();
      } catch (e) {
        console.error(e);
        setRazorpayFail(true);
      }
    };
    loadScript();
  }, [paymentData]);
  useEffect(() => {
    console.log('Check', paymentPending, appointmentID, paymentID);
    if (!paymentPending && !appointmentID && paymentID) {
      setStartTimer(true);
      // startCountDown(paymentID);
    }
  }, [paymentPending, paymentID, appointmentID]);
  useEffect(() => {
    if (!startTimer) return;
    console.log('Starting count down', startTimer);
    startCountDown(paymentID);
  }, [startTimer]);

  useEffect(() => {
    if (startTimer) {
      countDownRef.current = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            setMinutes((prevMinutes) => {
              if (prevMinutes === 0) {
                clearInterval(countDownRef.current);
                clearInterval(pollingRef.current);
                redirectTo(paymentData);
                return 0;
              }
              return prevMinutes - 1;
            });
            return 59;
          }
          return prevSeconds - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(countDownRef.current);
      clearInterval(pollingRef.current);
    };
  }, [startTimer]);

  const loadRazorpayScript = () =>
    new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve(true);

      const existing = document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      );

      if (existing) {
        existing.addEventListener('load', () => resolve(true));
        existing.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () =>
        reject(new Error('Razorpay script failed to load'));
      document.body.append(script);
    });

  // Open Razorpay Payment
  const openRazorpay = () => {
    console.log('Opened nb ');
    setRazorpayFail(false);
    const myHeaders = new Headers();
    myHeaders.append('db_ptr', paymentData.db_ptr);
    myHeaders.append('mode', 'booking');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${paymentData.authToken}`);

    const raw = JSON.stringify({
      paymentRefId: paymentData.order_id,
      paymentProvider: 'razorpay',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(
      `${process.env.REACT_APP_PAYMENT_BASE_URL}/payment/initiate-order`,
      requestOptions
    )
      .then((response) => response.text())
      .then(async (result) => {
        result = JSON.parse(result);
        console.log('Result of initiate payment', result.data.id);
        if (result.success) {
          const amount = Number(result.amount);
          // Your Razorpay API Key
          const razorpayApiKey = process.env.REACT_APP_RAZORPAY_KEY;
          const options = {
            key: razorpayApiKey,
            amount: amount * 100, // Amount in paise
            currency: 'INR',
            order_id: result.data.id,
            description: 'Payment for NURA',
            handler: function (response) {
              const paymentID = response.razorpay_payment_id;
              setPaymentID(paymentID);
              setPaymentPending(false);
            },
            prefill: {
              name: 'Customer Name',
              email: 'customer@example.com',
              contact: 'customer_phone_number',
            },
            modal: {
              ondismiss: function () {
                const finalPaymentData = {
                  ...paymentData,
                  paymentID: null,
                  paymentSuccess: false,
                };
                setPaymentData(finalPaymentData);
                setRazorpayFail(true);
                //redirectTo(finalPaymentData);
              },
            },
          };
          await loadRazorpayScript();
          const rzp = new window.Razorpay(options);
          rzp.open();
        }
      })
      .catch((error) => console.error(error));
  };
  const startCountDown = (pid) => {
    const maxAttempts = 200;
    let attempts = 0;
    pollingRef.current = setInterval(() => {
      attempts += 1;
      console.log('Attempts', attempts);
      updatePaymentStatus(pid, attempts); //change this
      if (attempts > maxAttempts) {
        clearInterval(pollingRef.current);
        clearInterval(countDownRef.current);
        const finalPaymentData = {
          ...paymentData,
          paymentID: pid,
          paymentSuccess: false,
        };
        setPaymentData(finalPaymentData);
        redirectTo(finalPaymentData);
      }
    }, 3000);
  };
  const updatePaymentStatus = (paymentID, attempts) => {
    console.log('Attempt inside', attempts);
    console.log('payment ID', paymentID);

    const myHeaders = new Headers();
    myHeaders.append('db_ptr', paymentData.db_ptr);
    myHeaders.append('Authorization', `Bearer ${paymentData.authToken}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/bookings/payment-status?payment_id=${paymentID}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        console.log('Payment status', result);
        const finalPaymentData = {
          ...paymentData,
          paymentID: paymentID,
          paymentSuccess: result.success,
          paymentResult: result,
        };
        if (result.success) {
          setAppointmentID(result.data);
          setPaymentData(finalPaymentData);
          clearInterval(countDownRef.current);
          clearInterval(pollingRef.current);
          redirectTo(finalPaymentData);
        }
      })
      .catch((error) => console.error(error));
  };

  const redirectTo = (paymentData) => {
    setPaymentData(paymentData);
    if (paymentData.paymentSuccess) {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(paymentData),
        process.env.REACT_APP_SECRET_KEY
      ).toString();

      // window.name is kept as a fallback (works in Chrome), but Firefox wipes
      // it on the cross-site redirect to the PWA. The URL survives the redirect
      // in every browser, so the payload also rides along as a query param.
      window.name = encrypted;

      const bookingStatusUrl = `${process.env.REACT_APP_PUBLIC_URL}/booking-status`;
      // window.location.href = 'https://nura-pwa.web.app/booking-status';
      // window.location.href = 'https://nura-74502.web.app/booking-status';
      window.location.href = `${bookingStatusUrl}?data=${encodeURIComponent(
        encrypted
      )}`;
      // window.location.href = `${bookingStatusUrl}`;
    } else {
      setAppointmentFailedMsg(true);
    }
  };
  const retryPaymentProcess = () => {
    console.log('Retrying ..');
  };
  return (
    <div
      className={'vertical-padding-32 '}
      style={{
        background: 'linear-gradient(180deg, #FBF9EE 5.29%, #82B8EE 72.12%)',
      }}
    >
      {contactSupport && (
        <div
          className="payment-modal-container"
          onClick={() => {
            setContactSupport(false);
          }}
          role="presentation"
        >
          <div
            style={{ width: '50% !important' }}
            className="padding-32 col support"
          >
            <div className="title-3 text-left-align text-primary">
              Need help with your payment?
            </div>
            <div className="form-text text-left-align regular text-primary">
              If you’re unsure about your payment status or need help completing
              your booking, fill out the form below and our team will get back
              to you shortly.
            </div>
            <div
              className="space-between mobile-col"
              style={{ gap: '1.5rem', width: '100%' }}
            >
              <div className="col flex-start-align" style={{ flex: '1' }}>
                <label htmlFor="email" className="body-3 text-grey-500">
                  Email address
                </label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  className="body-1 regular"
                />
              </div>
              <div className="col flex-start-align" style={{ flex: '1' }}>
                <label htmlFor="phone" className="body-3 text-grey-500">
                  Phone number
                </label>
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  className="body-1 regular"
                />
              </div>
            </div>
            <textarea
              rows={5}
              className="padding-12 margin-top-12"
              placeholder="Tell us what happened ..."
            />
            <div className="row justify-center " style={{ gap: '12px' }}>
              <button
                className="secondary-btn-regular"
                onClick={() => setContactSupport(false)}
                style={{ flex: 1 }}
              >
                Cancel
              </button>
              <button className="primary-btn-large" style={{ flex: 1 }}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {razorpayFail && (
        <Modal
          statusImage={true}
          paymentStatusImage={paymentFailed}
          title="Payment Failed"
          body="Your bank may still process the charge. If charged, the amount will be
          auto-refunded within 5–7 days."
          // buttonText1="Contact support"
          buttonText2="Retry payment"
          // buttonClick1={() => {
          //   setRazorpayFail(false);
          //   setContactSupport(true);
          // }}
          buttonClick2={() => {
            setRazorpayFail(false);
            setRetryPayment(true);
          }}
          onClose={() => setRazorpayFail(false)}
          // needHelp={true}
        />
      )}
      {razorpayPending && (
        <Modal
          statusImage={true}
          paymentStatusImage={paymentPendingGif}
          title="We're still waiting for your payment status"
          body="We haven’t received a confirmation yet. If your bank has charged you —we’ll process your booking as soon as the payment clears.If an amount has not be debited you can retry the payment or contact us for help."
          // buttonText1="Contact support"
          buttonText2="Retry payment"
          // buttonClick1={() => {
          //   setRazorpayPending(false);
          //   setContactSupport(true);
          // }}
          buttonClick2={() => {
            setRazorpayPending(false);
            setRetryPayment(true);
          }}
          onClose={() => setRazorpayPending(false)}
          // needHelp={true}
        />
      )}

      {appointmentFailedMsg && (
        <Modal
          statusImage={true}
          paymentStatusImage={paymentSuccess}
          title="Payment Successful"
          body="Your appointment details will be shared to you via email or mobile number."
          hasButton={false}
          onClose={() => setAppointmentFailedMsg(false)}
          showTimer={true}
          openSupport={() => {
            setAppointmentFailedMsg(false);
            setContactSupport(true);
          }}
          needHelp={true}
        />
      )}

      {retryPayment && (
        <Modal
          title="Retry payment?"
          body="If your earlier payment goes through, we’ll still confirm your booking
          and refund any duplicate automatically. You can safely try again now."
          buttonText1="Cancel"
          buttonText2="Retry now"
          buttonClick1={() => {
            setRetryPayment(false);
            window.location.href = process.env.REACT_APP_PUBLIC_URL;
          }}
          buttonClick2={() => {
            setRetryPayment(false);
            openRazorpay();
          }}
          onClose={() => setRetryPayment(false)}
        />
      )}

      <div
        className="payment-status-wrapper"
        style={{
          position: 'relative',
          height: '90vh',
          margin: 'auto',
        }}
      >
        {' '}
        <div className="slotContainer margin-bottom-24">
          <div className="vertical-padding-32 ">
            <div className="row slotRowContainer">
              {/* <div className="margin-right-24 text-coal-dark firstChild">
                  <div className="title-2 margin-bottom-12">
                    Choose how you’d like to pay
                  </div>
                  <div
                    className="bg-slate-100 border-radius-6 padding-16"
                    style={{
                      boxShadow:
                        ' 0px 1.444px 5.778px 0px rgba(80, 114, 169, 0.12)',
                    }}
                  >
                    <button
                      onClick={openRazorpay}
                      className="primary-btn-large enabled body-1 medium"
                    >
                      Pay with Razorpay
                    </button>
                  </div>
                </div> */}
            </div>
          </div>{' '}
        </div>
        {startTimer && (
          <div style={{ margin: 'auto', height: '100%' }}>
            <div
              className="col flex-center-align justify-center bg-white border-radius-12 padding-32 processing-card"
              style={{ margin: 'auto', height: 'max-content' }}
            >
              <div>
                <img src={paymentStatus} alt="waiting for appointment id" />
              </div>
              <div className="vertical-margin-32 text-coal-dark text-center-align">
                <div className="title-5 strong text-primary">
                  {minutes > 5
                    ? 'Processing your payment...'
                    : 'Still processing your payment...'}
                </div>
                <div className="vertical-margin-4 body-1 regular text-primary">
                  {minutes > 5
                    ? 'This may take a moment. Please don’t refresh or close the window.'
                    : 'If you’ve been charged but haven’t received confirmation, don’t worry—we’ll update you shortly.'}
                </div>
                <div className="row flex-center-align justify-center">
                  <img
                    className="margin-right-4"
                    src={clock}
                    alt="It may take upto 10 minutes"
                  />

                  <div className="text-grey-500">{`${minutes}:${seconds < 10 ? '0' + seconds : seconds}`}</div>
                </div>
              </div>
              <button className="text-slate-700 icon-btn">
                Need Help? Contact Support
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IndiaPayment;
